import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { savingsPlansGranularDataSelector } from "./savingsPlansGranularDataSelector";
import { SavingsPlanDateGranularDataPoint } from "../../../../../../services/cloudchipr.api";

export const savingsPlansGranularDataGroupedByDateSelector =
  createDraftSafeSelector(
    [savingsPlansGranularDataSelector],
    (data): Record<string, SavingsPlanDateGranularDataPoint> | undefined => {
      return data?.reduce(
        (acc, data) => {
          acc[data.date] = data;

          return acc;
        },
        {} as Record<string, SavingsPlanDateGranularDataPoint>,
      );
    },
  );
